exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swipe-box {\n    display: block;\n    width: 100%;\n    float: left;\n    margin: 0;\n}\n\n.visible {\n    display: block;\n}\n\n.hidden {\n    display: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/pages/details/details.component.css
// module id = ../../../../../src/app/pages/details/details.component.css
// module chunks = main